import {HttpError} from '@hconnect/common/types'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useSnackbar} from 'notistack'

import {GetKilnInfoQueryKey} from '@kilnfeature/api'
import {Api} from '@kilnfeature/api/api'
import {GetAssetConfigQueryKey, usePlantUpmId} from '@kilnfeature/api/queries'
import {AssetConfigurationDto} from '@kilnfeature/types'

export const useUpdateAssetConfig = () => {
  const {enqueueSnackbar, closeSnackbar} = useSnackbar()
  const plantUpmId = usePlantUpmId()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (kilnConfig: AssetConfigurationDto) => {
      const path = `asset-config/kms-data/plant/${plantUpmId}/upm-type/Department?typeUpmId=${kilnConfig.metadata.typeUpmId}`
      return (await Api.axiosInstance.put(path, {...kilnConfig.payload})).data
    },
    onSuccess: async (kilnConfig: AssetConfigurationDto) => {
      queryClient.setQueryData(
        [GetAssetConfigQueryKey, plantUpmId, kilnConfig.metadata.typeUpmId],
        kilnConfig
      )
      enqueueSnackbar('Kiln config updated successfully', {
        variant: 'success',
        autoHideDuration: 2500,
        preventDuplicate: true,
        onClick: () => closeSnackbar()
      })
      await queryClient.invalidateQueries({queryKey: [GetKilnInfoQueryKey, plantUpmId]})
    },
    onError: (error: AxiosError<HttpError>) => {
      enqueueSnackbar(`Kiln config could not be updated: ${error.message}`, {
        variant: 'error',
        preventDuplicate: true,
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        onClick: () => closeSnackbar()
      })
    }
  })
}
